






























































































































































import { FormulaireRepondu } from '@/domain/FormulaireRepondu'
import { Formulaire_Reponse_Statut, Formulaire_Reponse_Statut_ToText } from '@/domain/Formulaire_Reponse_Statut'
import Openable from '@/global/viewmodels/openable'
import SendMailModel from '@/layout/model/SendMailModel'
import mobileTypeMixin from '@/plugins/mixins/mobileTypeMixin'
import mixins from 'vue-typed-mixins'
import FormulaireReponseAdministrationMixin from './formulaireReponseAdministrationMixin'

export default mixins(FormulaireReponseAdministrationMixin, mobileTypeMixin).extend({
    components: {
        DialogMail: () => import('../../layout/components/DialogMail.vue'),
    },
    data() {
        return {
            headers: this.isMobileDevice()
                ? [
                      { text: 'Code', value: 'codeClientBiobank' },
                      { text: 'Actions', value: 'actions', align: 'center' },
                      { text: '', value: 'id' },
                  ]
                : [
                      { text: 'Date', value: 'dateCreation' },
                      { text: 'Formulaire utilisé', value: 'nomModeleFormulaire' },
                      { text: 'Utilisateur', value: 'user' },
                      { text: 'Code', value: 'codeClientBiobank' },
                      { text: 'Actions', value: 'actions', align: 'center' },
                      { text: 'Dernière action', value: 'lastUserTraitement' },
                      { text: '', value: 'id' },
                  ],
            emptyReponsesVisible: [] as number[],
            page: 1,
            pageCount: 0,
            repondues: 0,
            nonRepondues: 0,
        }
    },
    methods: {
        enumToText(statut: Formulaire_Reponse_Statut) {
            return Formulaire_Reponse_Statut_ToText(statut)
        },
        enumToColor(statut: Formulaire_Reponse_Statut) {
            switch (statut) {
                case Formulaire_Reponse_Statut.Envoyee:
                    return 'info'
                case Formulaire_Reponse_Statut.ValideParDirection:
                    return 'deep-purple lighten-4'
                case Formulaire_Reponse_Statut.EnCoursDeTraitement:
                    return 'warning'
                case Formulaire_Reponse_Statut.Traitee:
                    return 'success'
            }
        },
        setStatutWithText(id: number, enum_: string) {
            const value = enum_ == 'Envoyee' ? Formulaire_Reponse_Statut.Envoyee : enum_ == 'EnCoursDeTraitement' ? Formulaire_Reponse_Statut.EnCoursDeTraitement : enum_ == 'ValideParDirection' ? Formulaire_Reponse_Statut.ValideParDirection : Formulaire_Reponse_Statut.Traitee

            return this.setStatut(id, value)
        },
        isCollapsed(item: FormulaireRepondu) {
            return this.emptyReponsesVisible.indexOf(item.id) !== -1
        },
        collapseEmptyReponses(item: FormulaireRepondu) {
            const index = this.emptyReponsesVisible.indexOf(item.id)
            if (index === -1) this.emptyReponsesVisible.push(item.id)
            else this.emptyReponsesVisible.splice(index, 1)
        },
        reponsesRepondues(item: FormulaireRepondu) {
            return item.reponses.filter((x) => x.reponse !== null && x.reponse !== '')
        },
        reponsesNonRepondues(item: FormulaireRepondu) {
            return item.reponses.filter((x) => x.reponse === null || x.reponse === '')
        },
    },
})
